module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[5]248.e40b516.woff2";